<div class="row" *ngIf="key !== 'shape'">
  <div *ngIf="!usePlaceHolderLabel" class="col-md-3" [ngClass]="{'has-error': meta.fields[key].hasError}">
    <label class="control-label" [style]="meta.fields[key].hasError ? {'padding-top':'30px'} : ''" [for]="key">
      <span [innerHTML]="meta.fields[key].label | toTrusted"></span>
      <span *ngIf="meta.fields[key].required">*</span>
      <ng-content select="help-button"></ng-content>
    </label>
  </div>
  <div *ngIf="inputType | async as input"
       [ngClass]="{'has-error': meta.fields[key].hasError, 'col-md-12': usePlaceHolderLabel, 'col-md-9': !usePlaceHolderLabel}"
       [style]="meta.fields[key].hasError ? {'margin-top':'-15px'} : ''">
    <label class="control-label" *ngIf="meta.fields[key].hasError" id="{{key}}_error">
      {{ meta.fields[key].errorMessage }}</label>

    <input *ngIf="input === 'text'" [disabled]="meta.fields[key].read_only"
           type="text" [maxlength]="meta.fields[key].max_length" [readOnly]="meta.fields[key].read_only"
           class="form-control" [(ngModel)]="item[key]" [required]="meta.fields[key].required"
           (ngModelChange)="itemChange.emit(item)"
           [placeholder]="placeholder" [attr.name]="name"/>

    <div *ngIf="input === 'typeahead'" class="form-group has-feedback input-group">
      <input type="text" [maxlength]="meta.fields[key].max_length" [attr.name]="name"
             [disabled]="meta.fields[key].read_only"
             class="form-control has-clear" [(ngModel)]="item[key]" [required]="meta.fields[key].required"
             [placeholder]="placeholder" autocomplete="no"
             [ngbTypeahead]="getChoices" [focusFirst]="false"
             [resultFormatter]="formatChoices"
             [inputFormatter]="formatChoices"
             (focus)="focus$.next($any($event).target.value)"
             (click)="click$.next($any($event).target.value)"
             (selectItem)="selectTypeahead($event, item, key)">
      <i *ngIf="loadingChoices" class="fa fa-spinner fa-pulse form-control-feedback"></i>
      <i *ngIf="item[key]" (click)="clearTypeahead(key)"
         class="fa fa-times form-control-feedback"></i>
    </div>

    <span *ngIf="input === 'simple_typeahead'">
        <input type="text" [maxlength]="meta.fields[key].max_length" [attr.name]="name"
               class="form-control" [(ngModel)]="displayValues[key]" [required]="meta.fields[key].required"
               [placeholder]="placeholder"
               [ngbTypeahead]="getChoices"
               [inputFormatter]="formatter"
               (selectItem)="item[key]=$event.item.value"
               [disabled]="meta.fields[key].read_only">
        <i *ngIf="loadingChoices" class="fa fa-spinner fa-pulse"></i>
    </span>

    <input *ngIf="input === 'phone_number'"
           type="text" [maxlength]="meta.fields[key].max_length" [attr.name]="name"
           (change)="displayValues[key] = formatNumber(key)"
           class="form-control" [(ngModel)]="displayValues[key]" [required]="meta.fields[key].required"
           [placeholder]="placeholder" [disabled]="meta.fields[key].read_only"/>


    <span *ngIf="input === 'textarea_typeahead'">
        <textarea [readOnly]="meta.fields[key].read_only"
                  [(ngModel)]="item[key]" [required]="meta.fields[key].required" class="form-control"
                  [placeholder]="placeholder" [attr.name]="name"
                  (ngModelChange)="itemChange.emit(item)"
                  uib-typeahead="choice.value for choice in meta.fields[key].get_choices($viewValue)"
                  typeahead-loading="loadingChoices" typeahead-wait-ms="300"
                  typeahead-on-select="meta.fields[key].select_choice($item, item)">
        </textarea>
        <i *ngIf="loadingChoices" class="fa fa-spinner fa-pulse"></i>
    </span>

    <textarea *ngIf="input === 'textarea'"
              [readonly]="meta.fields[key].read_only"
              [(ngModel)]="item[key]" [required]="meta.fields[key].required" class="form-control"
              (ngModelChange)="itemChange.emit(item)" [disabled]="meta.fields[key].read_only"
              [placeholder]="placeholder" [attr.name]="name">
            </textarea>

    <input *ngIf="input === 'number'" type="number" [disabled]="meta.fields[key].read_only"
           class="form-control" [attr.name]="name" [readOnly]="meta.fields[key].read_only"
           [(ngModel)]="item[key]" string-to-number [required]="meta.fields[key].required"
           (ngModelChange)="itemChange.emit(item)"/>

    <input *ngIf="input === 'integer'" type="number" step="1" [disabled]="meta.fields[key].read_only"
           class="form-control" [attr.name]="name" [(ngModel)]="item[key]"
           (ngModelChange)="itemChange.emit(item)" [required]="meta.fields[key].required"
           [placeholder]="placeholder"/>

    <div *ngIf="input === 'datetime'" class="row">
      <div class="col-md-4">
        <div class="input-group">
          <input class="form-control" ngbDatepicker #d="ngbDatepicker"
                 [(ngModel)]="dates[key]" (ngModelChange)="applyDate(key)" placeholder="YYYY-MM-DD"
                 [disabled]="meta.fields[key].read_only"
                 [required]="meta.fields[key].required" [attr.name]="name" [readOnly]="meta.fields[key].read_only"/>
          <span class="input-group-btn">
                <button type="button" class="btn btn-default" (click)="d.toggle()" *ngIf="!meta.fields[key].read_only">
                  <i class="fa fa-calendar"></i>
                </button>
              </span>
        </div>
      </div>
      <div class="col-xs-6 col-sm-5 col-md-4 col-lg-4">
        <ngb-timepicker [(ngModel)]="times[key]" [meridian]="true" [spinners]="false"
                        [disabled]="meta.fields[key].read_only"
                        [readonlyInputs]="meta.fields[key].read_only" (ngModelChange)="applyDateTime(key)">
        </ngb-timepicker>
      </div>
      <div class="col-xs-6 col-sm-5 col-md-4 col-lg-4">
        <button type="button" class="btn btn-default" (click)="setCurrentDatetime(key)"
                *ngIf="!meta.fields[key].read_only">Now
        </button>
      </div>
    </div>

    <select *ngIf="input === 'select' && !loadingChoices"
            class="form-control"
            [disabled]="meta.fields[key].read_only"
            [attr.name]="name"
            [(ngModel)]="item[key]"
            (ngModelChange)="itemChange.emit(item)"
            [required]="meta.fields[key].required">
      <option *ngFor="let choice of meta.fields[key].choices" [value]="choice.value">
        {{ choice.display_name }}
      </option>
    </select>
    <i *ngIf="input === 'select' && loadingChoices" class="fa fa-spinner fa-pulse"></i>

    <div *ngIf="input === 'radio'"
         style="width: 100%; display: flex; justify-content: space-between; margin-left: auto;">
      <span *ngFor="let choice of meta.fields[key].choices">
        <label>
          <input type="radio" [attr.name]="name" [(ngModel)]="item[key]"
                 (ngModelChange)="itemChange.emit(item)" [disabled]="meta.fields[key].read_only"
                 [value]="choice.value" [name]="name"/>
          {{ choice.display_name }}
        </label>
      </span>
    </div>
    <style>
        .ui-select-search {
            border: none;
            width: 100% !important;
        }

        .ui-select-match {
            height: 100%;
            border: none;
        }

        .ui-select-dropdown {
            width: 100% !important;
        }

        .ui-select-match-item {
            font-size: 11px;
        }

    </style>
    <div *ngIf="input === 'multi-select'">
      <select multiple [(ngModel)]="item[key]" close-on-select="false" theme="bootstrap"
              (ngModelChange)="itemChange.emit(item)" [disabled]="meta.fields[key].read_only"
              style="height: 100% !important;">
        <option *ngFor="let choice of meta.fields[key].choices" [value]="choice.value"
                [innerHTML]="choice.display_name">
        </option>
      </select>
    </div>

    <div style="padding-top:1%;" *ngIf="input === 'checkbox'">
      <input type="checkbox" [(ngModel)]="item[key]" [attr.name]="name" (ngModelChange)="itemChange.emit(item)"
             [disabled]="meta.fields[key].read_only"/>
      @if (placeholder) {
        <label style="padding-left: 5px;">{{ placeholder }}</label>
      }
    </div>

    <!--  <input-->
    <!--    *ngIf="meta.fields[key].read_only && meta.fields[key].type !== 'datetime' &&-->
    <!--                              meta.fields[key].type !== 'many' && meta.fields[key].max_length === undefined"-->
    <!--    [placeholder]="placeholder" [attr.name]="name"-->
    <!--    type="text" class="form-control" [readonly]="true" [(ngModel)]="item[key]"/>-->

    <form *ngIf="meta.fields[key].type === 'attachment'"
          style="display: flex; flex-direction: row; align-items: center;">
      <input type="file" [id]="name" [attr.name]="name" (change)="encodeFile($event, key)"
             style="display: none;" class="form-control" [name]="name">
      <button class="btn btn-default" style="margin-bottom: 5px; margin-right: 5px; align-self: flex-start"
              [disabled]="meta.fields[key].read_only"
              (click)="openFileSelect()">Browse
      </button>
      <ng-container *ngIf="item.hasOwnProperty(key)">
        <app-display-field [type]="meta.fields[key].type" [value]="item[key]" [meta]="meta"></app-display-field>
      </ng-container>
    </form>

    <div *ngIf="input === 'many'"
         style="display: flex; flex-direction: row; justify-content: flex-start; gap: 10px; align-items: baseline; flex-wrap: wrap;">
      <div *ngFor="let choice of meta.fields[key].choices">
        <label (click)="setManyToMany($event, key, choice.value)">
          <input type="checkbox" [checked]="item[key].indexOf(choice.value) > -1"/>{{ choice.display_name }}
        </label>
      </div>
      <div style="cursor: pointer;" *ngIf="meta.fields[key].hasOwnProperty('add_many')" (click)="add_many(key)"><i
          class="fa fa-plus"></i> Add
      </div>
    </div>
    <!-- This doesn't make any sense.
    <div *ngIf="meta.fields[key].type === 'many' && meta.fields[key].choices.length > 5">
         <script type="text/ng-template" id="customManyTemplate.html">
             <a>
                 <span ng-bind-html="match.model.display_name | uibTypeaheadHighlight:query"></span>
             </a>
         </script>
         <input type="text" [maxlength]="meta.fields[key].max_length" display-input="meta.fields[key].choices"
                class="form-control" [(ngModel)]="item[key]" [required]="meta.fields[key].required"
                [placeholder]="placeholder"
                uib-typeahead="choice.value for choice in meta.fields[key].get_choices($viewValue)"
                typeahead-loading="loadingChoices" typeahead-wait-ms="300"
                typeahead-template-url="customManyTemplate.html" typeahead-on-select="meta.fields[key].select_choice($item, item)">
         <i *ngIf="loadingChoices" class="fa fa-spinner fa-pulse"></i>
     </div> -->

  </div>
</div>
<ng-container *ngIf="key ==='shape'">
  <div class="row" style="margin-bottom:10px" *ngIf="!meta.fields.shape.read_only">
    <div class="col-md-12">
      <br/>
      <ng-content select="[map-help]"></ng-content>
      <br/>
      <button type="button" class="btn btn-default" name="showMapButton" (click)="mapIsCollapsed = !mapIsCollapsed">
        <span *ngIf="mapIsCollapsed">Use Map to Set Location</span>
        <span *ngIf="!mapIsCollapsed">Hide Map</span>
      </button>
    </div>
  </div>
  <div class="row" style="margin-bottom:10px" #collapse="ngbCollapse" [(ngbCollapse)]="mapIsCollapsed">
    <!--  <div class="row" style="margin-bottom:10px" *ngIf="showMap">-->
    <div class="col-lg-8 col-md-12">
      <div #mapDiv style="height:450px; width: 100%; position: relative">
        <div style="text-align: center; position: absolute; top: 60%; z-index: 999; left: 50%; color:white;"
             *ngIf="updatingLocation">
          <i class="fa fa-spinner fa-pulse fa-3x"></i>
        </div>
        <div id="zoomToolbar" class="btn-toolbar">
          <div class="btn-group">
            <button id="zoomIn-button" class="btn btn-primary" (click)="zoomIn()" ngbTooltip="Zoom in"
                    container="body">
              <span class="fa fa-plus"></span>
            </button>
            <button id="zoomOut-button" class="btn btn-primary" (click)="zoomOut()" ngbTooltip="Zoom out"
                    container="body">
              <i class="fa fa-minus"></i>
            </button>
          </div>
          <div class="btn-group">
            <button id="center-button" class="btn btn-primary" (click)="goHome()"
                    ngbTooltip="Re-center map" container="body">
              <i class="fa fa-home"></i>
            </button>
          </div>
          <div class="btn-group">
            <button id="geolocation-button" class="btn btn-primary" (click)="zoomToCurrentLocation()"
                    ngbTooltip="Zoom to current location" container="body">
              <i class="fa fa-crosshairs"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="item.coordinates">
    <div class="row" style="margin-bottom: 10px;" style="align-items: flex-end; margin-bottom: 3px;"
         [style]="meta.fields.shape.hasError ? {'margin-top':'-15px'} : ''">

      <div class="col-md-3" [ngClass]="{'has-error': meta.fields.shape.hasError}">
        <label class="control-label">
          Latitude *
          <ng-content select="[location-help]"></ng-content>
        </label>
      </div>
      <div class="col-md-9" [ngClass]="{'has-error': meta.fields.shape.hasError}">
        <label class="control-label" *ngIf="meta.fields.shape.hasError" id="shape_error">
          {{ meta.fields[key].errorMessage }}
        </label>
        <input class="form-control" name="latitude" [(ngModel)]="item.coordinates.y" type="text"
               [readonly]="meta.fields.shape.read_only" [disabled]="meta.fields.shape.read_only"
               (change)="updatePointLocation()" [placeholder]="placeholder"/>
      </div>
    </div>
    <div class="row" style="margin-bottom: 10px;">
      <div class="col-md-3" [ngClass]="{'has-error': meta.fields.shape.hasError}">
        <label class="control-label">
          Longitude *
        </label>
      </div>
      <div class="col-md-9" [ngClass]="{'has-error': meta.fields.shape.hasError}">
        <input class="form-control" name="longitude" [(ngModel)]="item.coordinates.x" type="text"
               [readonly]="meta.fields.shape.read_only" [disabled]="meta.fields.shape.read_only"
               (change)="updatePointLocation()" [placeholder]="placeholder"/>
      </div>
    </div>
  </ng-container>
</ng-container>

